class NoOpAnalyticsApi {
  captureEvent(_event) {
  }
}

export { NoOpAnalyticsApi };
//# sourceMappingURL=NoOpAnalyticsApi.esm.js.map
